'use strict';

var d3 = require('d3');
var FlightLevelChart = function FlightLevelChart(AbstractChart, chartGroups, chartSimpleBars, chartCircles, chartTiles, chartMultiBrush, chartXAxis, chartYAxis, chartYAxisLines, chartConstants) {
  var chartParams = require('./Params');
  var chartScales = require('./Scales');
  var BAR_WIDTH = 30;
  var Chart = function Chart(container, formatters) {
    var self = this;
    AbstractChart.call(this, container);
    var dispatch = d3.dispatch('rangechange', 'rangechangeend');
    d3.rebind(this, dispatch, 'on');
    var groups = chartGroups('flightLabel', formatters.tooltipFormatter, true);
    var m1Bars = chartSimpleBars('m1');
    var m2Bars = chartSimpleBars('m2');
    var tiles = chartTiles('flightLabel', 'm2', 'tiles').withHeight(2);
    var circles = chartCircles('circles');
    var lines = chartYAxisLines();
    var brush = chartMultiBrush();
    var xAxis = chartXAxis(formatters.xAxisTickFormatter).withTextRotation(chartConstants.AXIS.SKEW.DEG_30).withRepetition(1);
    var yAxis = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT).withoutHorizontalLines();
    this.render = function (data) {
      data = data || this.data;
      var length = data.length;
      var chartWidth = length * BAR_WIDTH;
      this.initChart(data, [0, length], chartParams(chartWidth));
      this.scales = chartScales(this.params, this.data, this.visibleXRange);
      this.callForPreDataGroup([brush.withDomainRange(this.visibleXRange)], this.scales);
      this.callForDataGroup([lines, groups, m2Bars, m1Bars, tiles, circles, xAxis], this.scales);
      this.callForYAxis(yAxis, this.scales);
      if (brush.isSelectionInitialized()) {
        brush.updateBrush();
      }
    };
    this.withMetric = function (metric) {
      yAxis.label(metric.label);
      return this;
    };
    this.label = function (label) {
      yAxis.label(label);
    };
    this.setInitialSelection = function (range) {
      brush.setSelection(range);
    };
    brush.on('brushchange', function (range) {
      self.brushChangeAction(range, groups);
      dispatch.rangechangeend(range);
    });
    brush.on('brushend', function (range) {
      dispatch.rangechangeend(range);
    });
    groups.on('groupclick', function (d, i) {
      event.stopPropagation();
      brush.setSelection([i, i + 1]);
      dispatch.rangechangeend(brush.getSelection());
    });
    container.on('$destroy', function () {
      groups.on('groupclick', null);
      brush.on('brushchange', null);
      brush.on('brushend', null);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
FlightLevelChart.$inject = ['AbstractChart', 'ChartElementsGroup', 'ChartElementsSimpleBars', 'ChartElementsCircles', 'ChartElementsTiles', 'ChartElementsMultiBrush', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsYAxisLines', 'ChartElementsConstants'];
module.exports = FlightLevelChart;